import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverview } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import { JvvnlFeederDemand } from "./FeederDemand";

export function JvvnlOverviewTab() {
  return (
    <NewDynamicTab
      headerPrefixComponent={<TabSwitcher />}
      defaultDates={JvvnlOverview}
      header="Net Load & DRE Flow"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Overview: <JvvnlFeederDemand />,
      }}
    />
  );
}
